import React, { Component } from 'react';
import Datadiv from './Datadiv';

class Table extends Component {


    constructor(props)
    {
        super(props)
        this.state={
            loading: true,
            Data: null,
            lastData: null
        }
        this.pollData = this.pollData.bind(this)
    }

    componentDidMount(){
        this.pollData()
        setInterval(this.pollData, 5000)
        
    }
    pollData(){
        fetch("https://api.binance.com/api/v1/ticker/24hr#")
        .then(resp => resp.json())
        .then( data =>
        this.setState((prevState)  => ({
            Data: data, 
            loading: false,
            lastData: prevState.Data !== data ? prevState.Data : prevState.lastData
        })))
    }


    render() {
        const lists = ['0','1','90','59','65','178','312','127','70','194','422','423','452','424','512','485','426','443'];
        const listitem = lists.map(list => <Datadiv className='datadiv' pairid={list} value={this.state.Data} lastvalue={this.state.lastData}></Datadiv>);
        return (
            <div>
               <div className="databox">
                <div className="desktop">
                    <h2 className="pair">Pair Name</h2>
                    <h2 className="price">Price</h2>  
                    <h2 className="change">24Hr Change</h2>
                    <h2 className="volume">Volume</h2> 
                    <h2 className="hprice">24Hr Price</h2> 
                    <h2 className="action">Action</h2>
                    
                </div>
                <div>{this.state.loading || !this.state.Data ? (<div className="loader"> <p>Wait a moment...</p></div>):(
                <div >
                {listitem}
                </div>)}</div>
               </div>
               <div >
                   
                </div> 
            </div>
        )
    }
}

export default Table



// WEBPACK FOOTER //
// ./src/table.js